module.exports = __webpack_public_path__ + "static/media/preload.0d59b371.gif";